import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import './plugins/element';
import '@/assets/css/base.scss'; /*引入公共样式*/
import commonWs from 'common-ws';

// 2存储
import storage from './utils/storage';
// 3引入echarts
import echarts from 'echarts'

// 绑定到this上的方法
import fun from './utils/fun';
Vue.use(fun);

import { powerMixin } from './utils/mixin';
Vue.mixin(powerMixin)

import commonUrl from './utils/commonUrl';// 6公共访问链接比如oss
Vue.use(commonWs, {
  config: {
    processEnv: process.env,
    serviceMap: new Map([
      // 示例1
      // ['VUE_APP_SFC_API', [
      //     '/orderStats/select',
      //     '/statement/select',
      //     '/fileExport/select',
      // ]],
    ]),
  }
});

Vue.config.productionTip = false;

// 2存储
Vue.prototype.$storage = storage;
// 3引入echarts
Vue.prototype.$echarts = echarts;

// 6公共访问链接比如oss
Vue.prototype.$commonUrl = commonUrl;

//钩子登录拦截
router.beforeEach((to, from, next) => {
  //console.log(to)
  if (to.meta.isLogin) { // 判断该路由是否需要登录权限
    if (storage.get('user')) { // 判断本地是否登录
      next()
    } else {
      // 未登录,跳转到登录页面
      next({
        path: '/login'
      })
    }
  } else {
    if (storage.get('user')) {
      next('/welcome');
    } else {
      next();
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
